import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@ribera-web/app-token';
import { Observable } from 'rxjs';
import {
  MediaMainBanner,
  MediaMenu,
  MediaMenuMultiImage,
  MediaMenuQR,
} from './models/media';

@Injectable({
  providedIn: 'root',
})
export class MediaService {
  private http = inject(HttpClient);
  private config = inject(APP_CONFIG);
  private readonly URL_API = `${this.config.CMS_MICROSERVICE_API}/api/v1/media`;

  /**
   * Obtiene los banners principales para el home
   */
  findMainBanner(): Observable<MediaMainBanner[]> {
    return this.http.get<MediaMainBanner[]>(`${this.URL_API}/banner-main`);
  }

  /**
   * Obtiene el menú de servicios por ID de contenedor
   * @param id ID del contenedor (ej: 3 para home)
   */
  findAllMenu(id: number): Observable<MediaMenu[]> {
    return this.http.get<MediaMenu[]>(
      `${this.URL_API}/service/content/${id}`
    );
  }

  /**
   * Obtiene los códigos QR del menú
   */
  findQR(): Observable<MediaMenuQR[]> {
    return this.http.get<MediaMenuQR[]>(`${this.URL_API}/service/qr`);
  }

  /**
   * Obtiene el menú con múltiples imágenes por ID de contenedor
   * @param id ID del contenedor
   */
  findAllMenuMultiImage(id: number): Observable<MediaMenuMultiImage[]> {
    return this.http.get<MediaMenuMultiImage[]>(
      `${this.URL_API}/service/multi-image/content/${id}`
    );
  }
}
